(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AgenziaDialogController', AgenziaDialogController);

    AgenziaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Agenzia', 'Comune', 'Provincia'];

    function AgenziaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Agenzia, Comune, Provincia) {
        var vm = this;

        vm.agenzia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.comunes = Comune.query();
        vm.provincias = Provincia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.agenzia.id !== null) {
                Agenzia.update(vm.agenzia, onSaveSuccess, onSaveError);
            } else {
                Agenzia.save(vm.agenzia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:agenziaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
